module.exports = __webpack_public_path__ + "img/page1-bg-phone.18fb18cd.png";